// eslint-disable-next-line no-restricted-exports -- this is okay: https://github.com/airbnb/javascript/issues/2500
export * from './InlineEdit';
